export default __webpack_public_path__ + "static/media/museum_mezzanine.2815460f.png";